<template>
	<div class="footer">
		<div class="footerMain">
			<div class="footerMainL">
				<img class="logo" src="@/static/logo2.png" />
				<h2>长沙市问名师教育科技有限公司</h2>
			</div>
			<div class="footerMainC">
				<h3>联系我们</h3>
				<a href="mailto:service@wenms.com" @click="handleEmailClick" title="点击发送邮件或复制邮箱地址">
					邮箱：service@wenms.com
				</a>
				<p>地址：湖南省长沙市岳麓区桃子湖文创园A3栋3-1-4号</p>
				<ul>
					<li
						@click="$openUrl('https://file.wenms.com/Production/SchoolService/%E9%97%AE%E5%90%8D%E5%B8%88%E4%B8%89%E5%B8%88%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.html', '_blank')">
						用户服务协议</li>
					<li
						@click="$openUrl('https://file.wenms.com/Production/SchoolService/%E9%97%AE%E5%90%8D%E5%B8%88%E4%B8%89%E5%B8%88%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0%E9%9A%90%E7%A7%81%E5%8D%8F%E8%AE%AE.html', '_blank')">
						用户隐私政策</li>
					<li
						@click="$openUrl(`${$store.state.userInfo.role == 1 ? 'https://file.wenms.com/Production/SchoolService/Uom/stu/index.html' : 'https://file.wenms.com/Production/SchoolService/Uom/tch/index.html'}`, '_blank')">
						{{ $store.state.userInfo.role == 1 ? '使用手册' : '使用手册&FAQ' }}
					</li>
				</ul>
			</div>
			<div class="footerMainR">
				<div class="ewm">
					<img src="https://file.wenms.com/SchoolService/images/ewm2.png" />
					<p>问名师在线公众号</p>
				</div>
				<div class="ewm">
					<img src="https://file.wenms.com/SchoolService/images/ewm1.png" />
					<p>问名师资讯站公众号</p>
				</div>
				<div class="ewm">
					<img src="https://file.wenms.com/SchoolService/images/ewm3.png" />
					<p>长沙小问视频号</p>
				</div>
				<div class="ewm">
					<img src="https://file.wenms.com/SchoolService/images/ewm4.png" />
					<p>问名师在线视频号</p>
				</div>
			</div>
		</div>
		<div class="footerB">
			Copyright © w2025长沙市问名师教育科技有限公司版权所有 湘ICP备<span>2021016793</span>号
		</div>
	</div>
</template>
<script>
export default {
	name: 'Footer',
	methods: {
		handleEmailClick() {
			const email = 'service@wenms.com';
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(email).then(() => {
					this.$message.success('已复制邮箱地址：' + email);
				}).catch(() => {
					this.copyFallback(email);
				});
			} else {
				this.copyFallback(email);
			}
		},
		copyFallback(text) {
			try {
				const textarea = document.createElement('textarea');
				textarea.value = text;
				textarea.style.position = 'fixed';
				textarea.style.opacity = '0';
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('copy');
				document.body.removeChild(textarea);
				this.$message.success('已复制邮箱地址：' + text);
			} catch (err) {
				this.$message.info('邮箱地址：' + text);
			}
		},
		openEmail() {
			this.handleEmailClick();
			window.location.href = 'mailto:service@wenms.com';
		}
	}
}
</script>
<style lang="scss" scoped>
.footer {
	position: relative;
	background: #000125;
	height: 210px;
	overflow: hidden;
	color: #fff;

	.footerMain {
		margin: 0 auto;
		display: flex;
		align-items: center;
		padding: 33px 5vw 0;
		box-sizing: border-box;
		justify-content: space-between;

		.footerMainL {
			.logo {
				width: 85px;
			}

			h2 {
				font-size: 14px;
				font-weight: normal;
				margin-top: 10px;
				opacity: 0.8;
			}
		}

		.footerMainC {
			flex: 1;
			opacity: 0.8;
			font-size: 14px;
			margin-left: 4vw;

			h3 {
				padding-bottom: 14px;
				font-weight: normal;
			}

			a {
				text-decoration: underline;
				color: #fff;
				opacity: 0.5;
			}

			p {
				color: #fff;
				opacity: 0.5;
				margin-top: 8px;
			}

			ul {
				margin-top: 20px;
				display: flex;
				align-items: center;
				column-gap: 30px;

				li {
					cursor: pointer;
				}
			}
		}

		.footerMainR {
			display: flex;
			align-items: center;
			text-align: center;
			column-gap: 10px;

			img {
				width: 90px;
				height: 90px;
				margin-bottom: 10px;
			}

			p {
				opacity: 0.8;
			}
		}
	}

	.footerB {
		color: #fff;
		padding: 10px 0;
		text-align: center;
		margin-top: 25px;
		box-sizing: border-box;
		background: #14162D;
		opacity: 0.7;

		span {
			cursor: pointer;

			&:hover {
				color: #0D68FF;
			}
		}
	}
}
</style>